import { Box, Grid, Typography } from '@mui/material';
import AppleHealthCommonChart from 'pages/Dashboard/components/AppleHealthCommonChart';
import { TimeFrameOptions } from 'pages/Dashboard/utils/trackingUtils';
import { ReactComponent as HealthConnectImage } from 'assets/HealthConnect.svg';
import { ReactComponent as AppleHealthImage } from 'assets/AppleHealthIcon.svg';
import React, { useCallback, useEffect } from 'react';
import Theme from 'theme';

type Waypoint = {
    id: string;
    title?: string;
    subTitle?: string;
  };
interface HealthWaypointChartsSectionProps {
   appleHealthWaypointMap:{
    [key:string]:string
   };
    providerId:string;
    timeFrame:TimeFrameOptions;
    waypointsList: Waypoint[];
    patientId:string;
    openDrawer?:()=>void;
    onChangeTimeFrame: (v: string) => void;
}

export default function HealthWaypointChartsSection({
  waypointsList,
  appleHealthWaypointMap,
  timeFrame,
  providerId,
  patientId,
  openDrawer,
  onChangeTimeFrame }:
    HealthWaypointChartsSectionProps) {
  const keyArray = Object.keys(appleHealthWaypointMap);
  const reverseAppleHealthWaypointMap = keyArray.reduce((acc, key) => {
    acc[appleHealthWaypointMap[key]] = key;
    return acc;
  }, {} as { [key: string]: string });
  const [numberOfCards, setNumberOfCards] = React.useState(0);
  const [isLoading, setLoading] = React.useState(true);
  const [cardDataStatus, setCardDataStatus] = React.useState({
    sleepDerived: false,
    activityDerived: false,
    stepCountDerived: false,
    daylightExposure: false,
  });
  const chartOrder = ['sleepDerived', 'sleepAppleHealth', 'activityDerived', 'activityAppleHealth', 'stepCountDerived', 'daylightExposure'];
  const updateCardDataStatus = useCallback((type: string, data:boolean) => {
    setCardDataStatus((prev) => ({ ...prev, [type]: data }));
  }, [setCardDataStatus]);
  const waypointsListSorted = waypointsList
    ?.sort((a, b) => chartOrder
      .indexOf(reverseAppleHealthWaypointMap[a.id])
      - chartOrder.indexOf(reverseAppleHealthWaypointMap[b.id]));
  useEffect(() => {
    const number = Object.values(cardDataStatus).filter((v) => v).length;
    setNumberOfCards(number);
  }, [cardDataStatus]);

  useEffect(() => {
    if (waypointsList?.length === 0) {
      setLoading(false);
    }
  }, [waypointsList]);
  return (
    <Grid container spacing={2} justifyContent='center' mb={3}>
      {numberOfCards === 0 && !isLoading
        ? (
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            bgcolor='#0288D120'
            border='1px dashed'
            borderColor={Theme.custom.colors.primaryMain}
            borderRadius={1.5}
            padding={1.5}
            maxWidth='lg'
            marginX='auto'
            mb={3}
            flexGrow={1}
            mt={3}
          >
            <Box display='flex' alignItems='center'>
              <AppleHealthImage width={30} height={30} />
              <HealthConnectImage width={50} height={50} />
            </Box>
            <Typography variant='body1' mt={1} textAlign='center'>
              Activity and biometrics data is not currently available.
              <br />
              The patient hasn&apos;t enabled access to Apple Health or Google Health Connect.
            </Typography>
          </Box>
        )
        : null}
      {
        waypointsListSorted?.map?.((waypoint) => (
          <AppleHealthCommonChart
            timeFrame={timeFrame}
            waypointId={waypoint.id}
            patientId={patientId}
            providerId={providerId}
            title={waypoint.title ?? ''}
            subtitle={waypoint.subTitle ?? ''}
            type={reverseAppleHealthWaypointMap[waypoint.id] as 'sleepDerived' | 'activityDerived' | 'stepCountDerived'}
            openDrawer={openDrawer}
            key={waypoint.id}
            setCardStatus={updateCardDataStatus}
            onChangeTimeFrame={onChangeTimeFrame}
            numberOfCards={numberOfCards}
            setLoading={setLoading}

          />
        ))
      }
    </Grid>
  );
}
